export default __webpack_public_path__ + "static/media/Q20_4_resized.0c04f2b7.jpg";